import { apiEndpoint } from './apiEndpoint';
import { standardHeaders } from './standardHeaders';

export async function getFeedback(feedbackId: string) {
  const response = await fetch(`${apiEndpoint}/feedback/${feedbackId}`, {
    method: 'GET',
    headers: await standardHeaders(),
    mode: 'cors',
  });
  if (response.ok) {
    return await response.json();
  }
  return null;
}
